module.exports = __webpack_public_path__ + "img/egg-burger.5cae3c6b.png";